import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _jsxFileName = "/Users/brentvatne/coding/react-native-action-sheet/src/ActionSheet/ActionGroup.tsx";
import * as React from 'react';
import { StyleSheet, Text, Image, View, ScrollView } from 'react-native';
import TouchableNativeFeedbackSafe from './TouchableNativeFeedbackSafe';
var BLACK_54PC_TRANSPARENT = '#0000008a';
var BLACK_87PC_TRANSPARENT = '#000000de';
var DESTRUCTIVE_COLOR = '#d32f2f';

var ActionGroup = function (_React$Component) {
  _inherits(ActionGroup, _React$Component);

  function ActionGroup() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ActionGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ActionGroup)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this._renderRowSeparator = function (key) {
      return React.createElement(View, {
        key: key && "separator-" + key,
        style: [styles.rowSeparator, _this.props.separatorStyle],
        __source: {
          fileName: _jsxFileName,
          lineNumber: 37
        }
      });
    };

    _this._renderTitleContent = function () {
      var _this$props = _this.props,
          title = _this$props.title,
          titleTextStyle = _this$props.titleTextStyle,
          message = _this$props.message,
          messageTextStyle = _this$props.messageTextStyle,
          showSeparators = _this$props.showSeparators;

      if (!title && !message) {
        return null;
      }

      return React.createElement(View, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 52
        }
      }, React.createElement(View, {
        style: [styles.titleContainer, {
          paddingBottom: showSeparators ? 24 : 16
        }],
        __source: {
          fileName: _jsxFileName,
          lineNumber: 53
        }
      }, !!title && React.createElement(Text, {
        style: [styles.title, titleTextStyle],
        __source: {
          fileName: _jsxFileName,
          lineNumber: 54
        }
      }, title), !!message && React.createElement(Text, {
        style: [styles.message, messageTextStyle],
        __source: {
          fileName: _jsxFileName,
          lineNumber: 55
        }
      }, message)), !!showSeparators && _this._renderRowSeparator('title'));
    };

    _this._renderIconElement = function (iconSource, color) {
      var tintIcons = _this.props.tintIcons;

      if (!iconSource) {
        return null;
      }

      if (typeof iconSource === 'number') {
        var iconStyle = [styles.icon, {
          tintColor: tintIcons ? color : undefined
        }];
        return React.createElement(Image, {
          fadeDuration: 0,
          source: iconSource,
          resizeMode: "contain",
          style: iconStyle,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 70
          }
        });
      } else {
        return React.createElement(View, {
          style: styles.icon,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 72
          }
        }, iconSource);
      }
    };

    _this._renderOptionViews = function () {
      var _this$props2 = _this.props,
          options = _this$props2.options,
          icons = _this$props2.icons,
          destructiveButtonIndex = _this$props2.destructiveButtonIndex,
          onSelect = _this$props2.onSelect,
          startIndex = _this$props2.startIndex,
          length = _this$props2.length,
          textStyle = _this$props2.textStyle,
          tintColor = _this$props2.tintColor,
          showSeparators = _this$props2.showSeparators;
      var optionViews = [];
      var nativeFeedbackBackground = TouchableNativeFeedbackSafe.Ripple('rgba(180, 180, 180, 1)', false);

      var _loop = function _loop(_i) {
        var defaultColor = tintColor ? tintColor : (textStyle || {}).color || BLACK_87PC_TRANSPARENT;
        var color = _i === destructiveButtonIndex ? DESTRUCTIVE_COLOR : defaultColor;
        var iconSource = icons != null ? icons[_i] : null;
        optionViews.push(React.createElement(TouchableNativeFeedbackSafe, {
          key: _i,
          pressInDelay: 0,
          background: nativeFeedbackBackground,
          onPress: function onPress() {
            return onSelect(_i);
          },
          style: styles.button,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 102
          }
        }, _this._renderIconElement(iconSource, color), React.createElement(Text, {
          style: [styles.text, textStyle, {
            color: color
          }],
          __source: {
            fileName: _jsxFileName,
            lineNumber: 109
          }
        }, options[_i])));

        if (showSeparators && _i < startIndex + length - 1) {
          optionViews.push(_this._renderRowSeparator(_i));
        }
      };

      for (var _i = startIndex; _i < startIndex + length; _i++) {
        _loop(_i);
      }

      return optionViews;
    };

    return _this;
  }

  _createClass(ActionGroup, [{
    key: "render",
    value: function render() {
      return React.createElement(View, {
        style: styles.groupContainer,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 28
        }
      }, this._renderTitleContent(), React.createElement(ScrollView, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 30
        }
      }, this._renderOptionViews()));
    }
  }]);

  return ActionGroup;
}(React.Component);

ActionGroup.defaultProps = {
  title: null,
  message: null,
  showSeparators: false,
  tintIcons: true,
  textStyle: {}
};
export { ActionGroup as default };
var styles = StyleSheet.create({
  button: {
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexDirection: 'row',
    height: 56,
    paddingHorizontal: 16
  },
  groupContainer: {
    backgroundColor: '#ffffff',
    overflow: 'hidden'
  },
  icon: {
    width: 24,
    height: 24,
    marginRight: 32
  },
  message: {
    marginTop: 12,
    fontSize: 14,
    color: BLACK_54PC_TRANSPARENT,
    textAlignVertical: 'center'
  },
  rowSeparator: {
    backgroundColor: '#dddddd',
    height: 1,
    width: '100%'
  },
  text: {
    fontSize: 16,
    color: BLACK_87PC_TRANSPARENT,
    textAlignVertical: 'center'
  },
  title: {
    fontSize: 16,
    color: BLACK_54PC_TRANSPARENT,
    textAlignVertical: 'center'
  },
  titleContainer: {
    alignItems: 'flex-start',
    padding: 16,
    paddingTop: 24
  }
});